import React, { useEffect, useState } from "react";
import { getAllEvents } from "../../Api";

export default function EventsSection({ language = "EN" }) {

  const [eventsData, setEventsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const eventsPerPage = 2;
  const [currentPage, setCurrentPage] = useState(1);

  const langKey = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      loading: "Loading Events...",
      title1: "A window into how we",
      title2: "journey",
      title3: "together.",
      desc: "Life at JT Group, unfiltered.",
    },

    zh: {
      loading: "加载活动中...",
      title1: "见证我们如何",
      title2: "同行",
      title3: "前行",
      desc: "JT Group 的真实生活点滴",
    },
  };


  useEffect(() => {
    getAllEvents()
      .then((res) => {
        if (res.data.success) {
          setEventsData(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Events Fetch Error:", err);
      })
      .finally(() => setLoading(false));
  }, []);



  const indexOfLast = currentPage * eventsPerPage;
  const indexOfFirst = indexOfLast - eventsPerPage;
  const currentEvents = eventsData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(eventsData.length / eventsPerPage);



  if (loading) {
    return (
      <section className="py-20 text-center text-lg font-semibold">
        {text[langKey].loading}
      </section>
    );
  }



  return (
    <section className="bg-white py-10">

      {/* Heading */}
      <div className="max-w-3xl mx-auto mb-6 text-center">

        <h2 className="text-[34px] font-medium text-[#154059] leading-snug">

          {text[langKey].title1}{" "}
          <span className="text-[#C69C6D]">
            {text[langKey].title2}
          </span>{" "}
          {text[langKey].title3}

        </h2>

        <p className="text-gray-600 mt-2 leading-relaxed text-[15px]">
          {text[langKey].desc}
        </p>

      </div>



      <div className="max-w-7xl mx-auto px-4">

        {currentEvents.map((event) => {

          const formattedDate = new Date(event.eventDate)
            .toLocaleDateString(
              langKey === "zh" ? "zh-CN" : "en-GB",
              {
                year: "numeric",
                month: "short",
                day: "2-digit",
              }
            );

          return (

            <div key={event._id} className="mb-10">


              <div className="mb-6">

                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">

                  <h2 className="text-[26px] md:text-[34px] font-medium text-[#154059] text-center md:text-left">
                    {event.title?.[langKey]}
                  </h2>

                  <div className="flex justify-center md:justify-end">
                    <span className="bg-[#C09F7C] text-white px-10 py-2 text-xs md:text-sm font-semibold shadow-sm">
                      {formattedDate}
                    </span>
                  </div>

                </div>


                <p className="text-gray-700 text-justify">
                  {event.desc?.[langKey]}
                </p>

              </div>



              <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">


                <div className="lg:col-span-6">

                  <div className="h-[450px] overflow-hidden bg-black">

                    {event.videoUrl ? (

                      <video
                        src={`${process.env.REACT_APP_API_URL}/${event.videoUrl.replace(/\\/g, "/")}`}
                        className="w-full h-full object-cover"
                        controls
                        playsInline
                      />

                    ) : (

                      <img
                        src={`${process.env.REACT_APP_API_URL}/${event.images?.[0]?.replace(/\\/g, "/")}`}
                        alt=""
                        className="w-full h-full object-cover"
                      />

                    )}

                  </div>

                </div>



                <div className="lg:col-span-6 grid grid-cols-2 gap-6">

                  {event.images?.slice(0, 4).map((img, index) => (

                    <div key={index} className="h-[215px] overflow-hidden">

                      <img
                        src={`${process.env.REACT_APP_API_URL}/${img.replace(/\\/g, "/")}`}
                        alt=""
                        className="w-full h-full object-cover"
                      />

                    </div>

                  ))}

                </div>

              </div>



              <div className="mt-10 border-t-2 border-gray-300 relative">
                <span className="absolute -top-[8px] left-4 w-4 h-4 bg-[#C09F7C] border-2 border-gray-300 rounded-full"></span>
              </div>

            </div>

          );

        })}



        {totalPages > 1 && (

          <div className="flex justify-center space-x-3 mt-10">

            {[...Array(totalPages)].map((_, i) => (

              <button
                key={i}
                onClick={() => {
                  setCurrentPage(i + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className={`px-4 py-2 border ${
                  currentPage === i + 1
                    ? "bg-[#154059] text-white"
                    : "bg-white text-gray-700"
                }`}
              >
                {i + 1}
              </button>

            ))}

          </div>

        )}

      </div>
    </section>
  );
}